<template>
    <div class="pt-[20px] pr-[0px] bg-[#ededed]">
        <div class="max-w-[1400px] w-full container mx-auto">
            <div class="lg:pt-[60px] pr-[20px] pb-[2%] pl-[10px] max-w-[1400px]">
                <tiptelNavigation />
            </div>
        </div>
    </div>
    <div class="max-w-[1400px] w-full container mx-auto">
        <div class="pt-[30px] pr-[20px] pb-[40px] pl-[10px] max-w-[1400px]">
            <v-card class="w-full mx-auto" color="grey-lighten-3">
                <v-card-text>
                    <!-- search() function: searches for contactID, organisation, prename, name in CONTACT table -->
                    <v-text-field
                        :loading="loading"
                        density="comfortable"
                        type="input"
                        @input="search()"
                        variant="solo"
                        label="Institution, Vorname oder Nachname suchen"
                        title="Schule eingeben"
                        autofocus
                        v-model="searchTerm"
                        append-inner-icon="mdi-magnify"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-card-text>
            </v-card>
            <ContactsTable
                :load="load"
                :hasActions="true"
                :contacts="contacts"
                :selectMethod="selectContact"
                :contactsCount="5"
            />

            <div class="overflow-x-auto shadow mt-4 mb-[3%]">
                <table class="w-full border-[1px] text-left lg:text-xl">
                    <thead class="text-white">
                        <tr class="border-b-[1px] border-black bg-[#545656] py-2">
                            <th class="w-[8%] font-medium p-3">ID</th>
                            <th class="w-[30%] font-medium p-3">Organisation</th>
                            <th class="w-[16%] font-medium p-3">Name</th>
                            <th class="w-[16%] font-medium p-3">Vorname</th>
                            <th class="w-[10%] font-medium p-3 text-center">Abwählen</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="border-b-2" v-if="selectedContact.contactId">
                            <td class="w-[8%] font-medium p-3">
                                {{ selectedContact.contactId }}
                            </td>
                            <td class="w-[30%] font-medium p-3">
                                {{ selectedContact.organisation.name }}
                            </td>
                            <td class="w-[16%] font-medium p-3">
                                {{ selectedContact.person.familyName }}
                            </td>
                            <td class="w-[16%] font-medium p-3">
                                {{ selectedContact.person.firstName }}
                            </td>
                            <td class="w-[10%] font-medium p-3">
                                <button @click="deselect" class="w-full">
                                    <img
                                        src="@/assets/images/x.png"
                                        alt="Abwählen"
                                        class="lg:w-[35px] w-[20px] mx-auto"
                                    />
                                </button>
                            </td>
                        </tr>
                        <tr v-else>
                            <td class="w-[8%] font-medium p-3"></td>
                            <td class="w-[30%] font-medium p-3">Noch keinen Kontakt ausgewählt</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- dynamic, modelled input fields -->

            <v-form @submit.prevent="submit" ref="formRef">
                <v-container fluid>
                    <!-- name fields -->

                    <v-text-field
                        style="width: 33.3333%; display: inline-block"
                        class="p-[5px]"
                        :rules="[rules.prename, rules.required]"
                        v-model="selectedContact.person.firstName"
                        label="Vorname*"
                        placeholder="Max"
                        type="text"
                    >
                    </v-text-field>

                    <v-text-field
                        style="width: 33.3333%; display: inline-block"
                        class="p-[5px]"
                        :rules="[rules.secondname]"
                        v-model="selectedContact.person.secondName"
                        label="Zweitname"
                        placeholder="Michael"
                        type="text"
                    >
                    </v-text-field>

                    <v-text-field
                        style="width: 33.3333%; display: inline-block"
                        class="p-[5px]"
                        :rules="[rules.name, rules.required]"
                        v-model="selectedContact.person.familyName"
                        label="Name*"
                        placeholder="Mustermann"
                        type="text"
                    >
                    </v-text-field>

                    <!-- phone fields -->

                    <v-text-field
                        style="width: 25%; display: inline-block"
                        class="p-[5px]"
                        :rules="[rules.phone, rules.requiredFields]"
                        v-model="selectedContact.person.phone"
                        label="Telefon"
                        placeholder="+4179 123 4567"
                        type="input"
                    >
                    </v-text-field>

                    <v-text-field
                        style="width: 25%; display: inline-block"
                        class="p-[5px]"
                        :rules="[rules.phone, rules.requiredFields]"
                        v-model="selectedContact.person.mobile"
                        label="Mobil"
                        placeholder="+4179 123 4567"
                        type="input"
                    >
                    </v-text-field>

                    <!-- email fields -->

                    <v-text-field
                        style="width: 25%; display: inline-block"
                        class="p-[5px]"
                        :rules="[rules.email, rules.required]"
                        v-model="selectedContact.person.email"
                        label="E-Mail*"
                        placeholder="max.mustermann@gmail.com"
                        type="email"
                    >
                    </v-text-field>

                    <v-text-field
                        style="width: 25%; display: inline-block"
                        class="p-[5px]"
                        :rules="[rules.email]"
                        v-model="selectedContact.person.email_2"
                        label="E-Mail 2"
                        placeholder="erika.mustermann@gmail.com"
                        type="email"
                    >
                    </v-text-field>

                    <!-- address fields -->

                    <v-text-field
                        style="width: 25%; display: inline-block"
                        class="p-[5px]"
                        :rules="[rules.streetname]"
                        v-model="selectedContact.person.streetName"
                        label="Strasse"
                        placeholder="Musterstrasse"
                        type="text"
                    >
                    </v-text-field>

                    <v-text-field
                        style="width: 25%; display: inline-block"
                        class="p-[5px]"
                        :rules="[rules.streetnumber]"
                        v-model="selectedContact.person.streetNumber"
                        label="Hausnummer"
                        placeholder="123"
                        type="input"
                    >
                    </v-text-field>

                    <v-text-field
                        style="width: 25%; display: inline-block"
                        class="p-[5px]"
                        :rules="[rules.zip]"
                        v-model="selectedContact.person.zip"
                        label="PLZ"
                        placeholder="1234"
                        type="input"
                    >
                    </v-text-field>

                    <v-text-field
                        style="width: 25%; display: inline-block"
                        class="p-[5px]"
                        :rules="[rules.city]"
                        v-model="selectedContact.person.city"
                        label="Stadt"
                        placeholder="Musterstadt"
                        type="text"
                    >
                    </v-text-field>

                    <!-- text field to input message -->

                    <v-textarea
                        label="Text*"
                        hint="Bitte ausfüllen"
                        v-model="selectedContact.message"
                        :rules="[rules.required]"
                    >
                    </v-textarea>
                </v-container>

                <!-- submit button to send email -->

                <FullButton :handleClick="submit" width="100" title="Senden" colour="white" />
            </v-form>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { ref } from 'vue'
    import tiptelNavigation from '@/components/SubNavigations/TheTiptelNavigation.vue'
    import FullButton from '@/components/Buttons/FullButton.vue'
    import ContactsTable from '@/components/Contacts/ContactsTable.vue'
    import { makeABackendCall } from '@/BaseViewFunctionality'
    import { useContactStore as useStore } from '@/stores/ContactStore'
    import useContactStore from '@/utils/useContactStore'

    const contactStore = useStore()
    const { selectedContact, contacts, loading, fetchContacts } = useContactStore()
    const formRef = ref(null)

    async function fetchDataOnMounted() {
        await fetchContacts({ limit: 50, offset: 0, filter: '' })
    }

    fetchDataOnMounted()

    selectedContact.value = {}
    selectedContact.value.person = {}
    selectedContact.value.organisation = {}
    selectedContact.value.billing = {}
    selectedContact.value.message = ''

    const searchTerm = ref('')

    // functions defined and used here

    function search() {
        makeABackendCall({
            promise: contactStore.fetchContactsSearch,
            parameters: { limit: 50, offset: 0, filter: searchTerm.value },
            loading: loading.value,
        })
    }

    function deselect() {
        const text = selectedContact.value.message
        selectedContact.value = {}
        selectedContact.value.person = {}
        selectedContact.value.organisation = {}
        selectedContact.value.billing = {}
        selectedContact.value.message = text
    }

    // functions exported

    function load({ done }: { done: Function }) {
        makeABackendCall({
            promise: contactStore.fetchContactsLimit,
            parameters: {
                limit: 5,
                offset: contacts.value.length,
                filter: searchTerm.value,
                done: done,
            },
            loading: loading.value,
        })
    }

    function selectContact(contact: object) {
        const text = selectedContact.value.message
        selectedContact.value = contact
        selectedContact.value.message = text
    }

    function stripObjectRecursive(object: object) {
        for (const key in object) {
            if (typeof object[key] === 'object') {
                stripObjectRecursive(object[key])
            } else if (typeof object[key] === 'string') {
                object[key] = object[key].trim()
            }
        }
    }

    function onSubmitted() {
        selectedContact.value = {}
        selectedContact.value.person = {}
        selectedContact.value.organisation = {}
        selectedContact.value.billing = {}
        selectedContact.value.message = ''
    }

    function submit() {
        formRef.value?.validate().then((isValid) => {
            if (isValid.valid) {
                stripObjectRecursive(selectedContact.value)
                makeABackendCall({
                    promise: contactStore.createMessage,
                    parameters: {
                        message: selectedContact.value,
                        success: onSubmitted,
                    },
                    loading: loading.value,
                })
            } else {
                if (window.confirm('Fehlende Eingaben oder falsches Format. Trotzdem senden?')) {
                    stripObjectRecursive(selectedContact.value)
                    makeABackendCall({
                        promise: contactStore.createMessage,
                        parameters: {
                            message: selectedContact.value,
                            success: onSubmitted,
                        },
                        loading: loading.value,
                    })
                } else {
                    alert('Die Email wurde nicht gesendet.')
                }
            }
        })
    }

    // Rules / validation (Regex) - to be discussed with Teresa etc.

    const rules = {
        required: (value: string) => !!value || 'Bitte ausfüllen',
        email(value: string) {
            return value
                ? /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) ||
                      'E-mail muss gültig sein'
                : true
        },
        phone(value: string) {
            return value
                ? /^((\+?|00)\d{1,3}[ -]?)?(\(0\))?(\(?\d{1,4}\)?[ -]?)?\d{1,4}[ -]?\d{1,4}[ -]?\d{1,4}$/.test(
                      value
                  ) || 'Nummer muss gültig sein'
                : true
        },
        prename(value: string) {
            return value
                ? /^[a-zA-ZäöüÄÖÜßéèêà\'\- ]+$/.test(value) || 'Vorname muss gültig sein'
                : true
        },
        secondname(value: string) {
            return value
                ? /^[a-zA-ZäöüÄÖÜßéèêà\'\- ]+$/.test(value) || 'Zweitname muss gültig sein'
                : true
        },
        name(value: string) {
            return value
                ? /^[a-zA-ZäöüÄÖÜßéèêà\'\-]+$/.test(value) || 'Name muss gültig sein'
                : true
        },
        streetname(value: string) {
            return value
                ? /^[a-zA-ZäöüÄÖÜßéèêà\'\- ]+$/.test(value) || 'Strasse muss gültig sein'
                : true
        },
        streetnumber(value: string) {
            return value
                ? /^[0-9]{1,4}[A-Za-z]{0,2}$/.test(value) || 'Nummer muss gültig sein'
                : true
        },
        zip(value: string) {
            return value ? /^[0-9]{4,5}$/.test(value) || 'PLZ muss gültig sein' : true
        },
        city(value: string) {
            return value ? /^[\p{L} \-().]{2,}$/u.test(value) || 'Stadt muss gültig sein' : true
        },
        requiredFields() {
            const phone = selectedContact.value.person.phone
            const mobile = selectedContact.value.person.mobile
            return phone || mobile ? true : 'Bitte Telefon und/oder Mobile ausfüllen'
        },
    }
</script>
